<template>
  <div class="grid grid-cols-3 gap-4 lg:gap-8 m-5 session-responsive session-index">
    <div class="col-span-3 p-4 lg:col-span-1 grid-cols-3 lg:grid-cols-1 view-filter">
      <p class="hint"><i @click="long = !long" class="fad fa-arrows-h pointer" title="Expand types"></i>
        <span class="white-space: nowrap;" v-if="!long">{{ hint }}</span>
      </p>
      <div>
        <div class="flex flex-wrap flex-row">
          <template
              v-for="(sessionType, index) in sessionTypes" :title="sessionType.name"
              @click="addToTypes(sessionType)" @mouseover="hint = sessionType.name" @mouseleave="hint = ''">
            <span @click="addToTypes(sessionType)" @mouseover="hint = sessionType.name" @mouseleave="hint = ''" class="inline-flex space-x-4 items-center px-2.5 py-0.5
            rounded-md text-xs font-medium bg-gray-100 text-gray-800" v-if="long">{{ sessionType.name }}</span>
            <span @click="addToTypes(sessionType)" @mouseover="hint = sessionType.name" @mouseleave="hint = ''"
                  class="cursor-pointer inline-flex items-center px-3 py-0.5 mr-1 mb-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                  v-if="! long">{{ sessionType.short_name || sessionType.name }}</span>
          </template>
        </div>
      </div>
      <p class="mt-4 mb-2 font-medium text-gray-800 truncate">Local {{ event.timezone }}</p>
      <div class="flex flex-wrap flex-row">
        <div v-for="(localDay, index) in localDays">
          <span
              class="cursor-pointer inline-flex items-center px-3 py-0.5 mr-1 mb-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
              :title="localDay.name"
              @click="addToDays(localDay)">
            {{ localDay.format }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-span-3 lg:col-span-2 grid-cols-3 lg:grid-cols-2 p-4 view-list main">
      <h1>Quick Lookup (experimental)</h1>
      <p>By default, quick lookup starts from sessions that have recently started.</p>
      <p>You can also <a class="text-indigo-600" href="/sessions/responsive">view the schedule</a>.</p>

      <div>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <!-- Heroicon name: solid/search -->
            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                 fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
          <input type="text" name="email" id="email" @keyup="searchSessions" v-model="search"
                 class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                 placeholder="by title, id, content, or presenter">
        </div>
      </div>

      <div class="tags my-0.5">
        <span v-if="search"
              class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-indigo-100 text-indigo-700">
  {{ search }}
  <button v-on:click="resetSearch" type="button"
          class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white">

    <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
      <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
    </svg>
  </button>
</span>

        <span v-for="(selectedType, index) in selectedTypes"
              class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-gray-100 text-gray-800">
            {{ sessionTypeNameById(selectedType) }}

          <button v-on:click="removeFromTypes(selectedType)" type="button" class="flex-shrink-0 ml-0.5 h-4 w-4
          rounded-full inline-flex items-center justify-center text-gray-400 hover:text-gray-800 hover:text-gray-500
          focus:outline-none focus:bg-indigo-500 focus:text-white">
    <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
      <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
    </svg>
  </button>


          </span>

        <span v-for="(selectedDay, index) in selectedDays"
              class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-indigo-100 text-indigo-700">
  {{ selectedDay }}
  <button v-on:click="removeFromDays(selectedDay)" type="button"
          class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white">
    <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
      <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
    </svg>
  </button>
</span>


        <span v-for="(selectedPresenter, index) in selectedPresenters"
              class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-pink-100 text-pink-700">
            {{ selectedPresenter.name }}


           <button v-on:click="removeFromPresenters(selectedPresenter)" type="button"
                   class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-pink-400 hover:bg-pink-200 hover:text-pink-500 focus:outline-none focus:bg-pink-500 focus:text-white">
    <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
      <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
    </svg>
  </button>

          </span>
      </div>


      <ul style="margin-top: 20px;">
        <li class="session-overview" v-for="(session, index) in sessions" :key="session.id">
          <div class="grid grid-cols-12">
            <div class="col-span-2 lg:col-span-1">
              <div class="session-presenter" v-for="p in session.participants">
                <figure class="image" v-html="avatarImage(p)"></figure>
              </div>
            </div>
            <div class="col-span-10 lg:col-span-11">
              <h1 class="session-title"><a class="text-indigo-600" :href="sessionLink(session.id)">{{
                  session.title
                }}</a>
                <small>#{{ session.id }}</small>
                <i class='fa-heart'
                   :class="fasClasses(session)"
                   @click="toggle(session)"></i></h1>
              <p class="session-time">{{ getTime(session.starts_at, session.ends_at) }} <strong> | </strong>
                {{ getLocationName(session) }}</p>
              <p class="session-description">{{ session.description }}</p>
              <p class="session-type">{{ sessionTypeName(session) }}</p>
              <div class="session-presenters">
                    <span class="session-presenter" v-for="p in session.participants">
                      <span v-on:click="addToPresenters(p)" :class="pClass(p)">
                        {{ participantName(p) }}</span> <span class="delimiter"> / </span>
                    </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

// https://www.tutspack.com/blog/laravel-instant-search-example-using-vue-js-and-debounce
// https://stackoverflow.com/questions/49025064/vuejs-using-computed-property-for-array-elements


import axios from "axios";
import _ from "lodash";
import qs from "qs";

const moment = require('moment-timezone');

import VueSanitize from "vue-sanitize";

/*
Vue.use(VueSanitize, {
  allowedTags: ['strong', 'em', 'p']
});
*/

export default {
  name: "SessionResponsiveOld",
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
      required: true
    },
    favoriteSessions: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
  },
  created() {
    this.getTypes();
    this.getLocalDays();
    this.getInitial();

  },

  data() {
    return {
      sessions: [],
      sessionTypes: [],
      localDays: [],
      search: '',
      selectedTypes: [],
      selectedDays: [],
      sessionTypesArray: [],
      selectedPresenters: [],
      long: false,
      hint: '',
      timezone: this.event.timezone ?? 'UTC',
      favorites: this.favoriteSessions,
    }
  },
  methods: {
    fasClasses(session) {

      const loved = this.favorites.includes(session.id);

      return [
        'fa-heart',
        loved ? 'fas' : 'far'
      ];
    },
    toggle(session) {
      const loved = this.favorites.includes(session.id);
      loved ? this.destroy(session) : this.create(session);
    },
    create(session) {
      axios.post('/session/' + session.id + '/favorite').then(response => {
        this.favorites.push(session.id);
      })

    },

    destroy(session) {
      axios.delete('/session/' + session.id + '/favorite').then(response => {
        const index = this.favorites.indexOf(session.id);
        if (index !== -1) {
          this.favorites.splice(index, 1);
        }
      })

    },
    sanitize(text){
      return this.$sanitize(text);
    },

    pClass(p) {
      //console.log(p.is_main);
      //console.log(p.member);
      let c = p.is_main ? 'is-main' : 'not-main';
      //console.log(c);
      if (p.member) {
        c = c + ' is-member';
      }
      //console.log(c);
      return c + ' p';
    },
    participantLink(p) {
      return '/person/' + p.id;
    },

    participantName(p) {
      if (p.member) {
        return p.member.name;
      }
      //return 'unknown';
      return p.temp_name;
    },

    getLocationName: function (session) {
      if (session.location && session.location.name) {
        return session.location.name;
      }
      return 'Location not set'
    },

    getStartTime: function (isoTime) {

      if (!isoTime) {
        return '';
      }

      let localTime = moment.tz(isoTime, this.timezone);
      //let time = Date.parseLocale(isoTime);
      //console.log(localTime);
      //return localTime.format('H:mm');
      return localTime.format('ddd, MMMM Do, H:mm');
    },
    getEndTime: function (isoTime) {
      if (!isoTime) {
        return '';
      }
      let localTime = moment.tz(isoTime, this.timezone);
      //let time = Date.parseLocale(isoTime);
      //console.log(localTime);
      return localTime.format('H:mm [' + this.timezone + ']');
    },

    getTime: function (isoTimeStart, isoTimeEnd) {

      if (!isoTimeStart && !isoTimeEnd) {
        return 'Not yet scheduled';
      }
      let dayStart = '';
      let timeStart = '';
      let localTimeStart = '';
      if (isoTimeStart) {
        localTimeStart = moment.tz(isoTimeStart, this.timezone);
        dayStart = localTimeStart.format('MMMM Do');
        timeStart = localTimeStart.format('ddd, MMM Do, HH:mm');
      }
      let dayEnd = '';
      let timeEnd = '';
      let localTimeEnd = '';
      if (isoTimeEnd) {
        localTimeEnd = moment.tz(isoTimeEnd, this.timezone);
        dayEnd = localTimeEnd.format('MMMM Do');
        timeEnd = localTimeEnd.format('ddd, MMM Do, HH:mm ' + this.shortTimeZone);
      }

      if (dayStart && (dayStart === dayEnd)) {
        return localTimeStart.format('ddd, MMM Do, HH:mm') + ' ~ ' + localTimeEnd.format('HH:mm ' + this.shortTimeZone);
      }
      return timeStart + ' ~ ' + timeEnd;
    },

    addHint() {
      this.hint = 'hint';
    },
    resetSearch() {
      this.search = '';
      this.searchSessions();
    },
    addToPresenters(p) {

      if (!p.member) {
        return;
      }

      const newPresenter = {
        id: p.member.id,
        name: (p.member ? p.member.name : p.temp_name)
      };

      //console.log(newPresenter);

      if (!this.selectedPresenters.some(el => el.id === p.member.id)) {
        this.selectedPresenters.push(newPresenter);
        this.selectedTypes = [];
        this.selectedDays = [];
        this.searchSessions();
      }


    },
    removeFromPresenters(p) {

      const newPresenters = [];
      for (let i = 0; i < this.selectedPresenters.length; i++) {
        //console.log(this.selectedDays[i]);
        if (this.selectedPresenters[i].id !== p.id) {
          newPresenters.push(this.selectedPresenters[i]);
        }
      }
      this.selectedPresenters = newPresenters;
      this.searchSessions();
    },
    addToTypes(type) {

      if (this.selectedTypes.includes(type.id) === false) {
        this.selectedTypes.push(type.id);
        this.searchSessions();
      }


      /*if (!this.selectedTypes.some(el => el.id === type.id)) {
        this.selectedTypes.push(type.id);
      }*/

    },

    removeFromTypes(id) {

      //console.log(this.selectedTypes[i]);

      //this.selectedTypes.push(type);
      const newTypes = [];
      for (let i = 0; i < this.selectedTypes.length; i++) {
        //console.log(this.selectedTypes[i]);
        if (this.selectedTypes[i] !== id) {
          newTypes.push(this.selectedTypes[i]);
        }
      }
      this.selectedTypes = newTypes;
      this.searchSessions();
    },

    addToDays(day) {

      if (this.selectedDays.includes(day.date) === false) {
        this.selectedDays.push(day.date);
        this.selectedDays.sort();
        this.searchSessions();
      }
    },
    removeFromDays(date) {

      //console.log(this.selectedDays[i]);

      //this.selectedDays.push(type);
      const newDays = [];
      for (let i = 0; i < this.selectedDays.length; i++) {
        //console.log(this.selectedDays[i]);
        if (this.selectedDays[i] !== date) {
          newDays.push(this.selectedDays[i]);
        }
      }
      this.selectedDays = newDays;
      this.searchSessions();
    },

    avatarImage(p) {

      if (p.member) {
        return '<img class="inline-block h-10 w-10 rounded-full" src="' + p.member.avatar_path + '" alt="' + p.member.name + '">';
      }
      return '<img class="inline-block h-10 w-10 rounded-full" src="img/user-astronaut.png" alt="' + p.temp_name + '">';

    },

    sessionTypeName(session) {
      if (session.type != null) {
        return session.type.name;
      }
      return '-';
    },
    sessionTypeNameById(id) {

      const found = this.sessionTypes.find(el => el.id === id);
      return found.name;

    },
    selectedPresenterNameById(p) {

      //const found = this.sessionTypes.find(el => el.id === id);
      //return found.name;

    },
    sessionTypeShortNameById(id) {

      const found = this.sessionTypes.find(el => el.id === id);
      return found.short_name;

    },
    searchSessions: _.debounce(function () {

      let members = this.selectedPresenters.map(p => p.id);

      axios.get('/search/general', {
        params: {
          firstDay: -1,
          search: this.search,
          selectedTypes: this.selectedTypes,
          selectedDays: this.selectedDays,
          selectedMembers: members,
          limit: 50,
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessions = response.data;
          })
          .catch(error => {


          });
    }),
    sessionLocationName(session) {
      if (session.location != null) {
        return session.location.name;
      }
      return '-';
    },
    sessionLink(id) {
      return '/session/' + id;
    },
    getTypes() {
      axios.get(this.listUrl)
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessionTypes = response.data;
          })
          .catch(error => {

          });
    },
    getLocalDays() {
      axios.get(this.localListURL)
          .then(response => {
            this.localDays = response.data;
          })
          .catch(error => {


          });
    },
    getInitial() {

      // https://stackoverflow.com/questions/49944387/how-to-correctly-use-axios-params-with-arrays

      axios.get('/search/general', {
        params: {
          firstDay: -1,
          search: this.search,
          selectedTypes: this.selectedTypes
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessions = response.data;
          })
          .catch(error => {

          });
    },
  },
  computed: {
    listUrl() {
      return '/api/event/' + this.event.id + '/list/session_types';
    },
    localListURL() {
      return '/api/event/' + this.event.id + '/list/session_local_days';
    },
    shortTimeZone() {
      if (this.timezone === 'Asia/Tokyo') {
        return '[JST]';
      }
      return '[' + this.timezone + ']';
    }

  }
}
</script>

<style scoped>

.session-overview {
  border-radius: 0.9rem;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .03);
  border-style: solid;
  background-color: rgba(0, 0, 0, .01);
  margin-bottom: 1rem;
  padding: 20px;


}


.session-overview p{
  margin: 0;
}

.session-overview p.session-description{
  margin: 1em 0;
}

.session-overview p.session-time{
  margin: 0;
  font-size: 0.75rem;
}

.session-overview .session-title{
  color: #ccc ;
  font-size: 1.23rem;
  margin: 0;
}

.session-overview p.session-type{
  color: #999 ;
}

.session-responsive .view-filter {

}

.session-responsive .view-list {

}

.session-types span {
  border-radius: 30px;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.hint {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.delimiter {
  color: #ccc;
}

.session-presenter:last-child .delimiter {
  display: none;
}

figure.image {
  margin-bottom: 5px;
}

.p {

}

.p.is-member{
  color: #06bcef;
  cursor: pointer;
}

.p.is-main {
  font-weight: bold;
}

.fa-heart {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}

.red {
  color: red;
}

.pointer {
  cursor: pointer;
}


</style>